import React from "react";
import "./Button.css";
const Button = ({ title, onClick, style }) => {
  return (
    <div className="btn-container" style={style} onClick={onClick}>
      <p className="btn-title">{title}</p>
    </div>
  );
};

export default Button;
